import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Divider, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { EnhancedAccordion } from 'components/enhanced/accordion/EnhancedAccordion';
import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { useIsBottomFromTenantAdmin } from 'shared/permissions/useIsBottomFromTenantAdmin';
import ConfirmationButtonDialog from 'components/ui/feedback/ConfirmationButtonDelete';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../types';
import { AssignProductToLocationForm } from '../form/AssignProductToLocationForm';
import { AssignProductToWarehouseForm } from '../form/AssignProductToWarehouseForm';

interface WarehouseLocationTabProps {
  product: IProduct;
  fetchProduct: any;
  handleRemoveLocation: any;
  handleRemoveWarehouse: any;
}

function WarehouseLocationTab({
  product,
  fetchProduct,
  handleRemoveLocation,
  handleRemoveWarehouse
}: WarehouseLocationTabProps) {
  const { t } = useTranslation();
  const isTenantAdminBottom = useIsBottomFromTenantAdmin();

  return (
    <div className="flex flex-wrap">
      {/** WAREHOUSE */}
      <div className="w-full md:w-1/2 pr-2">
        {isTenantAdminBottom && (
          <EnhancedAccordion
            title={t('pages.product.add_warehouse')}
            subtitle={'Assegna questo prodotto a un nuovo magazzino gestito'}
            expandIcon={<AddCircleOutlineIcon color="primary" />}>
            <AssignProductToWarehouseForm productId={product.id} callback={fetchProduct} />
          </EnhancedAccordion>
        )}
        <EnhancedCard title={t('pages.product.warehouse_list')}>
          <List dense={true} className="ml-0">
            {product.warehouses.map((warehouse, idx) => (
              <ListItem
                key={idx}
                sx={{ padding: 0 }}
                secondaryAction={
                  isTenantAdminBottom && (
                    <ConfirmationButtonDialog
                      id={warehouse.id}
                      handleDelete={handleRemoveWarehouse}
                      iconButton={true}
                    />
                  )
                }>
                <ListItemButton>
                  <ListItemText primary={warehouse.code} />
                  <Divider variant="inset" component="li" />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </EnhancedCard>
      </div>

      {/** LOCATION */}
      <div className="w-full md:w-1/2 pl-2">
        <EnhancedAccordion
          title={t('pages.product.add_location')}
          subtitle={'Assegna questo prodotto a una nuova piazza'}
          expandIcon={<AddCircleOutlineIcon color="primary" />}>
          <AssignProductToLocationForm
            warehouses={product.warehouses}
            productId={product.id}
            callback={fetchProduct}
          />
        </EnhancedAccordion>
        <EnhancedCard title={t('pages.product.location_list')}>
          <List dense={true} className="ml-0">
            {product.locations.map((location, idx) => (
              <ListItem
                key={idx}
                sx={{ padding: 0 }}
                secondaryAction={
                  <ConfirmationButtonDialog
                    id={location.id}
                    handleDelete={handleRemoveLocation}
                    iconButton={true}
                  />
                }>
                <ListItemButton>
                  <ListItemText primary={`${location.code} - ${location.description}`} />
                  <Divider variant="inset" component="li" />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </EnhancedCard>
      </div>
    </div>
  );
}

export default WarehouseLocationTab;
